// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9622d77c","513":"a146c724","703":"b4b19ce7","787":"c238161a"}[chunkId] + ".chunk.js";
};